<template>
  <div class="app">
    <header-component ref="header" />
    <router-view />
  </div>
</template>

<script>
import HeaderComponent from '@/components/Header'
export default {
  name: 'Home',
  components: {
    HeaderComponent
  }
}
</script>
